import { styled } from '@mui/material';
import { colors } from '../../../../styles/globalStyles';
import { AnswerText } from '../../styles.css';

export const AnswerCounter = styled(AnswerText)({
    color: colors.main,
    fontWeight: 700,
});
